import { makeStyles } from '@material-ui/core';
import paleta from '../../configuraciones/paleta';

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: paleta.bar.user,
    borderRadius: 5,
    padding: theme.spacing(0.6, 1),
    color: paleta.sidebar.backgroundColor,
    userSelect: 'none',
    '&.disabled': {
      backgroundColor: paleta.activo.primary,
    },
  },
}));

export default styles;
